import { isNull as e, isUndefined as r } from "@sniptt/guards";
var d = (i) => !r(i) && !e(i);
export {
  d as t
};
